import { makeAutoObservable } from 'mobx'
import { Auction } from '../models/Auction'
import agent from '../api/agent'
import { store } from './store'

export default class AuctionListStore {
  auctionRegistry = new Map<string, Auction>()

  originalAuctions: Auction[] = []

  constructor() {
    makeAutoObservable(this)
  }

  get auctions() {
    return Array.from(this.auctionRegistry.values())
  }

  countMyAuctions = (email: string) => {
    const auctionsCreatedByUser = this.originalAuctions.filter((a) => a.post?.userEmail === email)
    const auctionsCreatedCount = auctionsCreatedByUser.length
    const remainingAuctions = Math.max(0, 5 - auctionsCreatedCount)
    return remainingAuctions
  }

  refreshAuctionRegistry = (auctions: Auction[]) => {
    const { formatDateLocal } = store.methodsStore
    this.auctionRegistry = new Map<string, Auction>()
    auctions.forEach((auction) => {
      auction.startingDate =new Date(formatDateLocal(auction.startingDate))
      auction.deadline = new Date(formatDateLocal(auction.deadline))
      this.auctionRegistry.set(auction.id, auction)
    })
  }

  loadAuctions = async () => {
    const { status, data: auctions } = await agent.Auctions.list()

    if (status === 200) {
      this.originalAuctions = auctions

      this.refreshAuctionRegistry(auctions)
    }
  }
}
